import { SyncErrorItem } from "./SyncErrorItem";

export default SyncErrorItem;
